import React from "react";
import { Box, Button, CircularProgress, Dialog, DialogProps, Typography } from "@mui/material";

interface LoadingCheckNetworkDialogProps extends DialogProps {
  open: boolean;
  title?: string;
  message?: string;
  onClose?: () => void;
}

/**
 * Popup kiểm tra mạng hoặc hiển thị tiến trình (đang xử lý / đang lưu / mất mạng)
 */
const LoadingCheckNetworkDialog: React.FC<LoadingCheckNetworkDialogProps> = ({
  open,
  title = "",
  message = "",
  onClose,
  ...props
}) => {
  return (
    <Dialog
      open={open}
      {...props}
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 3,
          width: 600,
          textAlign: "center",
          boxShadow: 6,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
      }}
    >
      {/* Tiêu đề */}
      <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2, textAlign: "center" }}>
        {title}
      </Typography>

      {/* Loading ở giữa */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          my: 2,
          height: 80,
        }}
      >
        <CircularProgress color="primary" size={60} thickness={5} />
      </Box>

      {/* Message */}
      <Typography sx={{ mb: 3 }}>{message}</Typography>

      {/* Button Close */}
      <Button
        variant="contained"
        color="primary"
        onClick={onClose}
        sx={{
          alignSelf: "center",
          px: 4,
          borderRadius: 2,
          textTransform: "none",
          fontWeight: "bold",
        }}
      >
        Đóng
      </Button>
    </Dialog>
  );
};

export default LoadingCheckNetworkDialog;
